import React, { useState } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { Box, IconButton, Typography } from "@material-ui/core";
import { useSelectedTheme, useIsDesktop, useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import {
  SwitchHorizontal2Icon,
  ChevronDown,
  ChevronUp,
} from "../../../../../assets/icons";

const CommissionTableActions = ({ onExpand, row, isExpanded, onMenuOpen }) => {
  const { isDarkMode } = useSelector((state) => state.theme);

  const {
    theme: { palette },
  } = useSelectedTheme();

  const { isDesktop } = useIsDesktop();
  const styles = useStyles({ isDesktop });
  const { translate } = useTranslate("AgentCommissionView");
  return (
    <>
      <Box className={styles.actionsContainer}>
        <Box className={styles.flex}>
          <IconButton
            className={styles.button}
            onClick={() => {
              onMenuOpen();
            }}
          >
            <SwitchHorizontal2Icon
              width="20"
              height="20"
              fill={palette.button.tertiaryGray_fg}
              style={{ padding: "0 2px" }}
            />
            <Typography style={isDarkMode ? { color: "#F5F5F6" } : null}>
              {translate("transaction-details-action")}
            </Typography>
          </IconButton>
          <IconButton
            className={clsx(styles.button, {
              [styles.disabledButton]: !row.invoices?.length,
            })}
            disabled={!row.invoices?.length}
            onClick={(e) => {
              e.stopPropagation();
              onExpand(row);
            }}
          >
            {isExpanded ? (
              <ChevronUp
                width="20"
                height="20"
                fill={palette.button.tertiaryGray_fg}
              />
            ) : (
              <ChevronDown
                width="20"
                height="20"
                fill={
                  !row.invoices?.length ? "" : palette.button.tertiaryGray_fg
                }
              />
            )}
          </IconButton>
        </Box>
      </Box>
    </>
  );
};

export default CommissionTableActions;
